<template>
	<div class="t-work-area__row">
		<div class="t-work-area__column_big _only t-settings">
			<div class="t-work-area__cell">
				<template v-if="user.login === '' && user.onlySocial">
					<h2>{{ pageText.loginPassword }}</h2>
					<template v-if="login_edit">
						<div class="t-input_320 t-input" :class="{_error: login.error}">
							<label>{{ login.title }}</label>
							<input v-model="login.value" @focus="login.error = false">
						</div>
						<div class="t-inputBox">
							<div class="t-input t-input_30" :class="{_error: new_password.error}">
								<label>{{ new_password.title }}</label>
								<input type="password" v-model="new_password.value" @focus="new_password.error = false">
							</div>
							<div class="t-input t-input_30" :class="{_error: new_password_double.error}">
								<label>{{ new_password_double.title }}</label>
								<input type="password" v-model="new_password_double.value"
									   @focus="new_password_double.error = false">
							</div>
						</div>
					</template>
					<div class="t-input_buttons">
						<button class="t-btn" v-if="!login_edit" @click.stop.prevent="login_edit = true"><span>{{ pageText.addBtn }}</span>
						</button>
						<template v-else>
							<button class="t-btn" @click.stop.prevent="SaveLoginPassword">
								<span>{{ pageText.saveBtn }}</span></button>
							<button class="t-btn t-btn_white" @click.stop.prevent="CancelLoginPassword"><span>{{ pageText.cancelBtn }}</span>
							</button>
						</template>
					</div>
				</template>
				<template v-else>
					<h2>{{ pageText.login }}</h2>
					<div class="t-input_30 t-input" :class="{_error: login.error}">
						<label>{{ login.title }}</label>
						<input v-model="login.value" :disabled="!login_edit" @focus="login.error = false">
					</div>
					<div class="t-input_buttons">
						<button class="t-btn" v-if="!login_edit" @click.stop.prevent="login_edit = true"><span>{{ pageText.updateBtn }}</span>
						</button>
						<template v-else>
							<button class="t-btn" @click.stop.prevent="SaveLogin"><span>{{ pageText.saveBtn }}</span>
							</button>
							<button class="t-btn t-btn_white" @click.stop.prevent="CancelLogin"><span>{{ pageText.cancelBtn }}</span>
							</button>
						</template>
					</div>
					<h2>{{ pageText.password }}</h2>
					<div class="t-inputBox" v-if="password_edit">
						<div class="t-input t-input_30" :class="{_error: old_password.error}" v-if="!user.onlySocial">
							<label>{{ old_password.title }}</label>
							<input type="password" v-model="old_password.value" @focus="old_password.error = false">
						</div>
						<div class="t-input t-input_30" :class="{_error: new_password.error}">
							<label>{{ new_password.title }}</label>
							<input type="password" v-model="new_password.value" @focus="new_password.error = false">
						</div>
						<div class="t-input t-input_30" :class="{_error: new_password_double.error}">
							<label>{{ new_password_double.title }}</label>
							<input type="password" v-model="new_password_double.value"
								   @focus="new_password_double.error = false">
						</div>
					</div>
					<div class="t-input_buttons">
						<button class="t-btn" v-if="!password_edit" @click.stop.prevent="password_edit = true"><span>{{ pageText.updateBtn }}</span>
						</button>
						<template v-else>
							<button class="t-btn" @click.stop.prevent="SavePassword" v-if="!user.onlySocial"><span>{{ pageText.saveBtn }}</span>
							</button>
							<button class="t-btn" @click.stop.prevent="CreatePassword" v-else><span>{{ pageText.saveBtn }}</span>
							</button>
							<button class="t-btn t-btn_white" @click.stop.prevent="CancelPassword"><span>{{ pageText.cancelBtn }}</span>
							</button>
						</template>
					</div>
				</template>
				<h2>{{ pageText.notificationLanguage }}</h2>
				<p class="t-settings__url" v-if="!notificationLanguage_edit">{{ user.notificationLanguage.label }}</p>
				<div class="t-input t-input_320" v-else>
					<v-select :options="notificationLanguage.options"
							  v-model="notificationLanguage.value"
							  :searchable="false"
							  :filterable="false"></v-select>
				</div>
				<div class="t-input_buttons">
					<button class="t-btn" v-if="!notificationLanguage_edit"
							@click.stop.prevent="notificationLanguage_edit = true"><span>{{ pageText.updateBtn }}</span>
					</button>
					<template v-else>
						<button class="t-btn" @click.stop.prevent="SaveNotificationLanguage"><span>{{ pageText.saveBtn }}</span>
						</button>
						<button class="t-btn t-btn_white" @click.stop.prevent="CancelNotificationLanguage"><span>{{ pageText.cancelBtn }}</span>
						</button>
					</template>
				</div>
				<h2>{{ pageText.url }}</h2>
				<p class="t-settings__url" v-if="!url_edit">{{ host }}<span>{{ url.value }}</span></p>
				<div class="t-input t-input_320" :class="{_error: url.error}" v-else>
					<input v-model="url.value" @focus="url.error = false">
					<span class="t-input__hint">{{ url.hint }}</span>
				</div>
				<div class="t-input_buttons">
					<button class="t-btn" v-if="!url_edit" @click.stop.prevent="url_edit = true"><span>{{ pageText.updateBtn }}</span>
					</button>
					<template v-else>
						<button class="t-btn" @click.stop.prevent="SaveUrl"><span>{{ pageText.saveBtn }}</span></button>
						<button class="t-btn t-btn_white" @click.stop.prevent="CancelUrl">
							<span>{{ pageText.cancelBtn }}</span></button>
					</template>
				</div>
				<h2>{{ pageText.privacy }}</h2>
				<div class="t-input">
					<input type="checkbox" class="t-checkbox_vertical" id="privacy" :checked="user.privacy"
						   @change="Privacy($event.target.checked)">
					<label for="privacy">{{ pageText.privacyLabel }}</label>
				</div>
				<h2>{{ pageText.notification }}</h2>
				<div class="t-input">
					<input type="checkbox" class="t-checkbox_vertical" id="notification" :checked="user.notification"
						   @change="Notification($event.target.checked)">
					<label for="notification">{{ pageText.notificationLabel }}</label>
				</div>
				<div class="t-socialAccounts" v-if="user.social">
					<div class="t-socialAccounts__item" v-for="(item, index) in user.social" :key="'social_' + index">
						<h3 class="_blue">{{ item.title }}</h3>
						<p>{{ item.text }}</p>
						<button v-if="item.tied" class="t-btn" @click.prevent="Untie(item.id)" ><span>{{ pageText.untie }}</span>
						</button>
						<a v-else class="t-btn" :href="item.url" ><span>{{ pageText.tie }}</span></a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    let localeText = {
        url: process.env.NODE_ENV !== 'production' ? 'staticText/settingsPage.json' : 'staticText',
        main: {
            login: "Логин",
            password: "Пароль",
            loginPassword: "Логин и пароль",
            updateBtn: "Изменить",
            saveBtn: "Сохранить",
            cancelBtn: "Отменить изменения",
            addBtn: "Добавить",
            url: "Адрес на сайте",
            privacy: "Приватность",
            privacyLabel: "Показывать мои уроки на сайте",
            notification: "Уведомления",
            notificationLabel: "Получать уведомления по Email",
            untie: "Отвязать",
            tie: "Привязать",
            formEmail: "Электронная почта для входа",
            formPassword: "Текущий пароль",
            formPasswordNew: "Новый пароль (не менее 8 символов)",
            formPasswordNewDouble: "Новый пароль ещё раз",
            formUrl: "Латинские буквы, цифры и знак подчеркивания",
            msgLoginCreate: "Логин для входа создан. Перейдите на почту для подтверждения.",
            msgLoginUpdate: "Логин изменен",
            msgPasswordUpdate: "Пароль изменен",
            msgUrlUpdate: "Адрес изменен",
            msgAccountUntie: "Аккаунт отвязан от профиля",
            notificationLanguage: "Язык уведомлений"
        }
    };

    import {store} from '../../store'

    import {mapActions, mapGetters} from 'vuex';

    export default {
        data() {
            return {
                pageText: {},

                host: window.location.host + '/users/',
                login_edit: false,
                login: {
                    title: '',
                    value: '',
                    error: false,
                    pattern: /^[^@]{2,}@[^@.]{2,}\.[^@]{2,}$/
                },
                password_edit: false,
                old_password: {
                    title: '',
                    value: '',
                    error: false,
                    pattern: /^[a-zA-Z0-9_]{6,30}$/
                },
                new_password: {
                    title: '',
                    value: '',
                    error: false,
                    pattern: /^[a-zA-Z0-9_]{8,30}$/
                },
                new_password_double: {
                    title: '',
                    value: '',
                    error: false,
                    pattern: /^[a-zA-Z0-9_]{8,30}$/
                },
                url_edit: false,
                url: {
                    value: '',
                    error: false,
                    pattern: /^[a-z0-9_]{6,30}$/,
                    hint: '',
                },
                notificationLanguage_edit: false,
                notificationLanguage: {
                    searchable: false,
                    title: '',
                    value: store.getters['profile/user'].notificationLanguage,
                    options: store.getters['handbook/notificationLanguage'],
                    error: false,
                    pattern: ''
                }
            }
        },
        computed: {
            ...mapGetters('profile', ['user'])
        },
        methods: {
            ...mapActions(['UpdatePreloadState']),
            ...mapActions('profile', ['setUserInfo', 'updateLogin', 'updateUrl', 'updatePrivacy', 'LoadUserInfo', 'updateNotification']),
            ...mapActions('msg', ['showMsg']),
            load(pageText) {
                this.pageText = pageText;
                this.login.value = this.user.login;
                this.url.value = this.user.url;

                this.login.title = pageText.formEmail;
                this.old_password.title = pageText.formPassword;
                this.new_password.title = pageText.formPasswordNew;
                this.new_password_double.title = pageText.formPasswordNewDouble;
                this.url.hint = pageText.formUrl;
                this.notificationLanguage.title = pageText.notificationLanguage;

                // setTimeout(() => {
                //     this.UpdatePreloadState(false);
                // }, 200)
            },
            SaveLoginPassword() {
                let is_valid = true;

                if (!this.new_password.pattern.test(this.new_password.value)) {
                    this.new_password.error = true;
                    is_valid = false;
                }
                if (!this.new_password_double.pattern.test(this.new_password_double.value)) {
                    this.new_password_double.error = true;
                    is_valid = false;
                }
                if (this.new_password.value !== this.new_password_double.value) {
                    this.new_password.error = true;
                    this.new_password_double.error = true;
                    is_valid = false;
                }
                if (!this.login.pattern.test(this.login.value)) {
                    this.login.error = true;
                    is_valid = false;
                }

                if (is_valid) {
                    let fd = new FormData();
                    fd.append('login', this.login.value);
                    fd.append('password', this.new_password.value);

                    this.$http.put('addLogin', fd)
                        .then(response => response.json())
                        .then(data => {
                            if (data.success) {
                                this.LoadUserInfo();
                                this.showMsg(this.pageText.msgLoginCreate);

                                this.password_edit = false;
                                this.new_password.value = '';
                                this.new_password_double.value = '';
                                this.login_edit = false;
                            } else {
                                let text = '';
                                for (let key in data.errors) {
                                    this[key].error = true;
                                    text += data.errors[key]
                                }
                                this.showMsg(text);
                            }
                        })
                        .catch(error => {
                            this.showMsg('Упс, что-то пошло не так, попробуйте позже');
                        })
                }
            },
            CancelLoginPassword() {
                this.login_edit = false;
                this.login.value = this.user.login;
                this.login.error = false;
                this.old_password.value = '';
                this.new_password.value = '';
                this.new_password_double.value = '';
                this.old_password.error = false;
                this.new_password.error = false;
                this.new_password_double.error = false;
            },
            SaveLogin() {
                if (!this.login.pattern.test(this.login.value)) {
                    this.login.error = true;
                } else {
                    let fd = new FormData();
                    fd.append('login', this.login.value);

                    this.$http.put('update_login', fd)
                        .then(response => {
                            if (response.body.success) {
                                this.updateLogin(this.login.value);
                                this.showMsg(this.pageText.msgLoginUpdate);
                                this.login_edit = false;
                                this.LoadUserInfo();
                            } else {
                                let error_text = [];

                                for (let key in response.body.errors) {
                                    error_text.push(response.body.errors[key].join(', '));
                                }

                                this.showMsg(error_text.join(', '));

                                this.login_edit = false;
                                this.login.value = this.user.login
                            }
                        }, response => {
                            this.showMsg('Упс, что-то пошло не так, попробуйте позже');
                            this.login_edit = false;
                            this.login.value = this.user.login
                        });
                }
            },
            CancelLogin() {
                this.login_edit = false;
                this.login.value = this.user.login;

                this.login.error = false;
            },
            SavePassword() {
                let is_valid = true;

                if (!this.old_password.pattern.test(this.old_password.value)) {
                    this.old_password.error = true;
                    is_valid = false;
                }
                if (!this.new_password.pattern.test(this.new_password.value)) {
                    this.new_password.error = true;
                    is_valid = false;
                }
                if (!this.new_password_double.pattern.test(this.new_password_double.value)) {
                    this.new_password_double.error = true;
                    is_valid = false;
                }
                if (this.new_password.value !== this.new_password_double.value) {
                    this.new_password.error = true;
                    this.new_password_double.error = true;
                    is_valid = false;
                }

                if (is_valid) {
                    let fd = new FormData();
                    fd.append('old_password', this.old_password.value);
                    fd.append('new_password', this.new_password.value);

                    this.$http.put('update_password', fd)
                        .then(response => response.json())
                        .then(data => {
                            if (data.success) {
                                this.showMsg(this.pageText.msgPasswordUpdate);

                                this.password_edit = false;
                                this.old_password.value = '';
                                this.new_password.value = '';
                                this.new_password_double.value = '';
                                this.LoadUserInfo();
                            } else {
                                let text = '';
                                for (let key in data.errors) {
                                    this[key].error = true;
                                    text += data.errors[key]
                                }
                                this.showMsg(text);
                            }
                        })
                        .catch(error => {
                            this.showMsg('Упс, что-то пошло не так, попробуйте позже');
                        })
                }
            },
            CreatePassword() {
                let is_valid = true;

                if (!this.new_password.pattern.test(this.new_password.value)) {
                    this.new_password.error = true;
                    is_valid = false;
                }
                if (!this.new_password_double.pattern.test(this.new_password_double.value)) {
                    this.new_password_double.error = true;
                    is_valid = false;
                }
                if (this.new_password.value !== this.new_password_double.value) {
                    this.new_password.error = true;
                    this.new_password_double.error = true;
                    is_valid = false;
                }
                if (is_valid) {
                    let fd = new FormData();
                    fd.append('new_password', this.new_password.value);

                    this.$http.post('create_password', fd)
                        .then(response => response.json())
                        .then(data => {
                            if (data.success) {
                                this.showMsg(this.pageText.msgPasswordUpdate);

                                this.password_edit = false;
                                this.new_password.value = '';
                                this.new_password_double.value = '';
                                this.LoadUserInfo();
                            } else {
                                let text = '';
                                for (let key in data.errors) {
                                    this[key].error = true;
                                    text += data.errors[key]
                                }
                                this.showMsg(text);
                            }
                        })
                        .catch(error => {
                            this.showMsg('Упс, что-то пошло не так, попробуйте позже');
                        })
                }
            },
            CancelPassword() {
                this.password_edit = false;
                this.old_password.value = '';
                this.new_password.value = '';
                this.new_password_double.value = '';

                this.old_password.error = false;
                this.new_password.error = false;
                this.new_password_double.error = false;
            },
            SaveUrl() {
                if (!this.url.pattern.test(this.url.value)) {
                    this.url.error = true;
                } else {
                    let fd = new FormData();
                    fd.append('url', this.url.value);

                    this.$http.put('update_url', fd)
                        .then(response => response.json())
                        .then(data => {
                            if (data.success) {
                                this.updateUrl(this.url.value);
                                this.showMsg(this.pageText.msgUrlUpdate)
                            } else {
                                let error_text = [];

                                for (let key in data.errors) {
                                    error_text.push(data.errors[key].join(', '));
                                }

                                this.showMsg(error_text.join(', '));
                            }
                        })
                        .catch(error => {
                            this.showMsg('Упс, что-то пошло не так, попробуйте позже');
                        })
                        .then(() => {
                            this.url_edit = false;
                            this.url.value = this.user.url;
                        })
                }
            },
            CancelUrl() {
                this.url_edit = false;
                this.url.value = this.user.url;

                this.url.error = false;
            },
            Privacy(e) {
                let fd = new FormData();
                fd.append('privacy', e);

                this.$http.put('update_privacy', fd)
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            this.updatePrivacy(e);
                        } else {
                            document.getElementById('privacy').checked = !e;
                            this.updatePrivacy(!e);
                            this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                        }
                    })
                    .catch(error => {
                        document.getElementById('privacy').checked = !e;
                        this.updatePrivacy(!e);
                        this.showMsg('Упс, что-то пошло не так, попробуйте позже');
                    });
            },
            Notification(e) {
                let fd = new FormData();
                fd.append('notification', e);

                this.$http.put('update_notification', fd)
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            this.updateNotification(e);
                        } else {
                            document.getElementById('notification').checked = !e;
                            this.updateNotification(!e);
                            this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                        }
                    })
                    .catch(error => {
                        document.getElementById('notification').checked = !e;
                        this.updateNotification(!e);
                        this.showMsg('Упс, что-то пошло не так, попробуйте позже');
                    });
            },
            Untie(id) {
                let fd = new FormData();
                fd.append('id', id);

                this.$http.put('untie', fd)
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            this.LoadUserInfo();
                            this.showMsg(this.pageText.msgAccountUntie);
                        } else {
                            if (data.errors.id){
                                this.showMsg(data.errors.id[0]);
                            }
                            this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                        }
                    })
                    .catch(error => {
                        this.showMsg('Упс, что-то пошло не так, попробуйте позже');
                    });
            },
            SaveNotificationLanguage() {
                let fd = new FormData();

                fd.append('value', this.notificationLanguage.value.value);

                this.$http.put('updateNotificationLanguage', fd)
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            this.LoadUserInfo();
                            this.notificationLanguage_edit = false;
                        } else {
                            this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                        }
                    })
                    .catch(error => {
                        this.showMsg('Упс, что-то пошло не так, попробуйте позже');
                    });
            },
            CancelNotificationLanguage() {
                this.notificationLanguage_edit = false;
                this.notificationLanguage.value = this.user.notificationLanguage;
            }
        },
        beforeRouteLeave(to, from, next) {
            // this.UpdatePreloadState(true);
            next();
        },
        beforeRouteEnter(to, from, next) {
            let count = 0;
            let pageText = {};

            store.dispatch('staticText/LoadPageText', localeText).then((data) => {
                pageText = data;

                count++;
                RunNext();
            });
            store.dispatch('profile/LoadUserInfo').then(() => {
                count++;
                RunNext();
            });
            store.dispatch('handbook/LoadNotificationLanguage').then(() => {
                count++;
                RunNext();
            });
            let RunNext = () => {
                if (count > 2)
                    next(vm => vm.load(pageText))
            }
        }
    }
</script>

<style lang="sass">
	.t-settings
		h2
			color: $blue
			margin: 0 0 16px
		&__url
			margin: 0 0 24px
			span
				color: $blue
		.t-socialAccounts
			display: flex
			align-items: flex-start
			padding-top: 4px
			margin-top: 36px
			border-top: 1px solid $disabled
			&__item
				margin: 32px 32px 0 0
				h3
					font-size: 22px
					margin-bottom: 8px
				p
					margin-bottom: 8px
</style>



// WEBPACK FOOTER //
// src/vue_pages/Profile/Settings.vue